/* View tabs above the home toolbar; 1–9 pick them in this order. The views themselves are hardcoded in viewRegistry.ts. */
import { VIEWS } from "../viewRegistry"

interface IViewTabsProps {
  activeId: string
  onSelect: (id: string) => void
}

export function ViewTabs({ activeId, onSelect }: IViewTabsProps) {
  return (
    <div className="hd-views" role="tablist" aria-label="Dashboard views">
      {VIEWS.map((view, i) => (
        <span key={view.id} className="hd-view" data-active={view.id === activeId}>
          <button type="button" role="tab" aria-selected={view.id === activeId} onClick={() => onSelect(view.id)}>
            {i < 9 && <span className="hd-key">{i + 1}</span>}
            {view.name}
          </button>
        </span>
      ))}
    </div>
  )
}
